var exports = {
  "i": "ClaimAccountModal.module__resendRow___LUtSSz",
  "h": "ClaimAccountModal.module__status___LUtSSz",
};

module.exports = exports;
